import { AdminStoreDetailTemplate } from "../../Templates/AdminStoreDetailTemplate";

export const AdminStoreDetail = () => {
  return <AdminStoreDetailTemplate />;
};
